const files = require.context('.', true, /\.\/.+\/index\.js$/);
let modules = {};
files.keys().forEach(key => {
  Object.assign(modules, files(key))
});
export default modules;